import { useTranslate } from 'core/hooks/useTranslate';
import LineWithText from 'core/modules/atoms/LineWithText';
import BookCard from 'core/modules/components/cards/BookCard';
import MosaicList from 'core/modules/components/lists/components/MosaicList';
import { isEmptyObj } from 'core/utils/validation';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, SelectCustomizable, Tag } from 'ui';

const AddClassStep = ({ mode, books, courses, createClassAndCourse, selectedCourse, setSelectedCourse, addCourseToChannel }) => {
  const { t } = useTranslate();

  const [selectedBook, setSelectedBook] = useState({});
  const [showFinalizeStep, setShowFinalizeStep] = useState(false);

  useEffect(() => {
    if (selectedBook && !isEmptyObj(selectedBook)) {
      setSelectedCourse('');
    }
  }, [selectedBook]);

  useEffect(() => {
    if (selectedCourse) {
      setSelectedBook({});
    }
  }, [selectedCourse]);

  return (
    <div style={{ marginTop: 16, marginBottom: 16, textAlign: 'center' }}>
      {!showFinalizeStep && (
        <>
          {courses.length > 0 && books.length > 0 && (
            <>
              {mode !== 'register' && (
                <>
                  <div className="signup-step__teams-select-class">{t('signup:Select a course for this channel')}</div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: 2 }}>
                      <SelectCustomizable
                        style={{ height: '100%', marginRight: 16 }}
                        options={courses.map((course) => ({
                          label: course.name,
                          key: course.guid,
                        }))}
                        placeholder={t('signup:Choose the class you want to assign')}
                        onChange={(e) => {
                          setSelectedCourse(e.key);
                        }}
                      />
                    </div>
                    <div style={{ flex: 1, marginLeft: 16 }}>
                      <Button
                        text={t('signup:Add this course to channel')}
                        isDisabled={!selectedCourse}
                        onClick={() => {
                          addCourseToChannel(selectedBook);
                          setShowFinalizeStep(true);
                        }}
                        isFullWidth
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          {courses.length > 0 && books.length > 0 && (
            <div style={{ marginTop: 16, marginBottom: 16 }}>
              <LineWithText text="O" />
            </div>
          )}

          {books.length > 0 && (
            <>
              <div className="signup-step__teams-select-class-to-create">{t('signup:Create course for channel')}</div>
              <MosaicList
                columns={2}
                items={books.map((book) => (
                  <BookCard
                    {...book}
                    key={book.guid}
                    subtext={
                      <div>
                        <span className="new-classroom__year">{t(`education-years:${book.education_year?.guid}`)}</span>{' '}
                        <span className="new-classroom__level">{t(`education-levels:${book.education_level?.guid}`)}</span>
                      </div>
                    }
                    customRight={<Tag label={t('common:Proximamente')} />}
                    text={book.courseName}
                    onChangeSelected={() => {
                      setSelectedBook(book);
                    }}
                    view={'selectable'}
                    type=""
                    selected={book.guid === selectedBook.guid}
                    useWindow={false}
                    getScrollParent={() => { }}
                    configProgramPicture={true}
                    disabledTitle={null}
                  />
                ))}
              />
              <Button
                text={t('signup:Create course for channel')}
                isDisabled={!selectedBook.guid}
                onClick={() => {
                  createClassAndCourse(selectedBook);
                  setShowFinalizeStep(true);
                }}
                isFullWidth
              />
            </>
          )}

          {courses.length === 0 && books.length === 0 && (
            <div className="signup__license-disclaimer">
              No se han encontrado cursos activos para añadir a este canal. <br /> Si desea obtener información sobre cómo obtener una licencia, comuníquese con
              nosotros a través de digital@edelvives.es.
            </div>
          )}
        </>
      )}

      {showFinalizeStep && <div className="signup-step__teams-add-class">{t('signup:Click on the below save button to finalize the process')}</div>}
    </div>
  );
};

AddClassStep.propTypes = {
  mode: PropTypes.string,
  books: PropTypes.array,
  courses: PropTypes.array,
  createClassAndCourse: PropTypes.func,
  selectedCourse: PropTypes.string,
  setSelectedCourse: PropTypes.func,
  addCourseToChannel: PropTypes.func,
};

AddClassStep.defaultProps = {
  mode: '',
  books: [],
  courses: [],
  createClassAndCourse: () => { },
  selectedCourse: '',
  setSelectedCourse: () => { },
  addCourseToChannel: () => { },
};

export default AddClassStep;
